<mat-dialog-content class="add-edit">
	<button class="o-modal-dismiss">
		<epi-icon
			[mat-dialog-close]="false"
			use="close"
			color="black"
			size="18"
		></epi-icon>
	</button>
	<epi-heading
		level="2"
		appears-as="1"
		color="primary"
		*ngIf="!isAgeError"
		class="u-margin-bottom-small"
	>
		Tell Us About Your {{ data.mode === 'add' ? 'Additional' : '' }} Pet
	</epi-heading>
	<span
		*ngIf="isAgeError"
		class="errorheading"
	>Due to your pet's age and location we are unable to complete your quote.</span>
	<div *ngIf="!isAgeError">

		<form
			[formGroup]="addEditPetForm"
			class="add-edit__form u-margin-top-medium"
		>
			<div
				role="presentation"
				class="u-row inline-form-row name-row"
			>
				<div
					role="presentation"
					class="u-row__column pet-name-wrapper"
				>
					<epi-input input-id="addEditPetName">
						<div class="form_input" slot="epiInput">
						<input
							type="text"
							formControlName="name"
							slot="epiInput"
							name="name"
							data-quat="input_addEditName"
							maxlength="100"
							class="form_input-input inside"
							(focus)="onFocus('name')"
							(blur)="onBlur('name')"
						/>
						<label
							class="form_input-label"
							[class.focused]="focusedInput ==='name' || name?.value"
							for="name"
						>
							Pet's Name
						</label>
					</div>
						<epi-validation-error *ngIf="name?.errors?.required && (name?.touched)">
							Please enter your pet's name
						</epi-validation-error>
						<epi-validation-error *ngIf="name?.errors?.pattern && (name?.touched)">
							Your pet's name must start with a letter or number and may not contain special characters.
						</epi-validation-error>
						<epi-validation-error *ngIf="name?.errors?.maxlength && (name?.touched)">
							Your pet's name may not be longer than 100 characters.
						</epi-validation-error>
					</epi-input>
				</div>

			<div
				role="presentation"
				class=" u-row__column  toggle-wrapper toggle-wrapper__species "
			>
				<epi-option-toggle
					qeCustomInput
					[formControlName]="'species'"
					id="add-pet-species"
					size="medium"
					layout="dense"
					data-quat="input_pet-species"
					(epiValueChanged)="onRadioChange"
				>
					<epi-toggle-choice
						id="add-pet-species-dog"
						value="dog"
						popular="false"
						slot="option"
						[selected]="species?.value === 'dog'"
						data-quat="input_speciesDog"
						(epi-toggle_selectionChange)="onRadioChange('pet_species', 'dog')"
					>
					<div class="option-toggle">
						<qe-dog-icon *ngIf="species?.value === 'dog'" variableName="white"></qe-dog-icon>
						<qe-dog-icon *ngIf="species?.value !== 'dog'" variableName="brandSecondary"></qe-dog-icon>
						<div>Dog</div>
					</div>
					</epi-toggle-choice>
					<epi-toggle-choice
						id="add-pet-species-cat"
						value="cat"
						popular="false"
						slot="option"
						data-quat="input_speciesCat"
						[selected]="species?.value === 'cat'"
						(epi-toggle_selectionChange)="onRadioChange('pet_species', 'cat')"
					>
					<div class="option-toggle">
						<qe-cat-icon *ngIf="species?.value === 'cat'" variableName="white"></qe-cat-icon>
						<qe-cat-icon *ngIf="species?.value !== 'cat'" variableName="brandSecondary"></qe-cat-icon>
						<div>Cat</div>
					</div>
					</epi-toggle-choice>
				</epi-option-toggle>
				<epi-validation-error *ngIf="species?.invalid && species?.touched">
					Please select your pet's species.
				</epi-validation-error>
			</div>

			<div class=" u-row__column toggle-wrapper toggle-wrapper__species ">
				<epi-option-toggle
					qeCustomInput
					formControlName="gender"
					size="medium"
					layout="dense"
					data-quat="input_pet-sex"
				>
					<epi-toggle-choice
						id="add-pet-gender-emale"
						value="male"
						popular="false"
						slot="option"
						[selected]="gender?.value === 'male'"
						data-quat="input_genderMale"
						(epi-toggle_selectionChange)="onRadioChange('pet_sex', 'male')"
					>
						<div class="option-toggle">
							<qe-male-icon *ngIf="gender?.value === 'male'" variableName="white"></qe-male-icon>
							<qe-male-icon *ngIf="gender?.value !== 'male'" variableName="brandSecondary"></qe-male-icon>
							<div>Male</div>
						</div>
					</epi-toggle-choice>
					<epi-toggle-choice
						id="add-pet-gender-female"
						value="female"
						popular="false"
						slot="option"
						data-quat="input_genderFemale"
						[selected]="gender?.value === 'female'"
						(epi-toggle_selectionChange)="onRadioChange('pet_sex', 'female')"
					>
						<div class="option-toggle">
							<qe-female-icon *ngIf="gender?.value === 'female'" variableName="white"></qe-female-icon>
							<qe-female-icon *ngIf="gender?.value !== 'female'" variableName="brandSecondary"></qe-female-icon>
							<div>Female</div>
						</div>
					</epi-toggle-choice>
				</epi-option-toggle>
				<epi-validation-error *ngIf="gender?.invalid && gender?.touched">
					Please select your pet's sex.
				</epi-validation-error>
			</div>
		</div>
			<div
				role="presentation"
				class="u-row inline-form-row u-margin-top-small breed-row"
			>
				<div
					role="presentation"
					class="u-row__column m--tablet-6 toggle-wrapper"
				>
				<qe-autosearch
					*ngIf="(breedsList$ | async)?.length"
					#addEditBreedEl
					qeCustomInput
					[breed]="breed?.value"
					[disabled]="!species?.value"
					[formGroup]="addEditPetForm"
					inputId="addEditBreed"
					data-quat="input_breed"
					[options]="breedsList$ | async"
				></qe-autosearch>
				<epi-validation-error *ngIf="breed?.invalid && breed?.touched" class="breed-error">
					Please select your pet's breed.
				</epi-validation-error>
				</div>

				<div
					role="presentation"
					class="u-row__column m--tablet-6  "
				>
					<qe-age-select-menu
						*ngIf="(breedsList$ | async)?.length"
						#ageSelectEl
						qeCustomInput
						data-quat="input_age"
						input-id="age-select"
						[value]="age?.value"
						[formGroup]="addEditPetForm"
						[options]="ageOptions | keyvalue"
					>
					</qe-age-select-menu>
					<epi-validation-error *ngIf="age?.touched && age?.invalid">
						Please select your pet's age
					</epi-validation-error>
					<epi-validation-error *ngIf="showAgeError">
						Pets need to be at least 6 weeks of age to enroll
					</epi-validation-error>
				</div>
			</div>

			<div
			*ngIf="serviceDogEnabled && species?.value === 'dog'"
			 class="u-row inline-form-row u-margin-top-small"
			 role="presentation"
		 >
			 <div class=" u-row__column">
				 <epi-label>Is this dog a service dog?</epi-label>
				 <epi-option-toggle
					qeCustomInput
					formControlName="serviceDog"
					size="medium"
					layout="dense"
					data-quat="input_serviceDog"
					id="add-pet-servicedog"
				>
				 <epi-toggle-choice
					 id="add-pet-servicedog-yes"
					 value="yes"
					 popular="false"
					 slot="option"
					 data-quat="input_serviceDogYes"
					 [selected]="serviceDog?.value === 'yes'"
					 (epi-toggle_selectionChange)="onRadioChange('service_dog', 'yes')"
				 >
					 Yes
				 </epi-toggle-choice>
				 <epi-toggle-choice
				 	id="add-pet-servicedog-no"
					 value="no"
					 popular="false"
					 slot="option"
					 data-quat="input_serviceDogNo"
					 [selected]="serviceDog?.value === 'no'"
					 (epi-toggle_selectionChange)="onRadioChange('service_dog', 'no')"
				 >
					 No
				 </epi-toggle-choice>
			 </epi-option-toggle>
			 <epi-validation-error *ngIf="serviceDog?.invalid && serviceDog?.touched">
				 Please specify if your dog is a service animal.
			 </epi-validation-error>
				 <div >
				 <span class="service_dog" *ngIf="serviceDog?.value === 'yes'"> <img src="../../../assets/icons/exclamation-circle.png" alt="Service Dog" /> <p>We are able to offer a 5% discount for service dogs that are trained to mitigate the symptoms or effects of their owners' disability. Currently, we cannot provide a discount for emotional support animals or therapy dogs. May not apply in all states</p>.</span>
			 </div>
		 </div>
		 </div>
		</form>
		<section class="add-edit__actions u-margin-top-medium">
			<button
				qeBaseButton
				[disabled]="addEditPetForm.invalid || this.tooManyPets"
				class="add-edit__actions-item"
				data-gtm="addEditPetButton"
				data-quat="action_addEditCtaButton"
				(click)="handleSubmit()"
			>{{ data.mode === 'add' ? 'Select Coverage' : 'Update Pet' }}</button>
			<epi-button
				[mat-dialog-close]="false"
				color="secondary"
				button-type="minimal"
				class="add-edit__actions"
				data-quat="action_addEditCancelButton"
			><span class="cancel-button__text">
				<epi-icon
					[mat-dialog-close]="false"
					color="primary"
					use="close"
					size="16"
				></epi-icon>
				Cancel</span>
			</epi-button>
		</section>
		<p
			*ngIf="tooManyPets"
			class="add-edit__max-pets u-margin-top-small"
			role="alert"
			aria-live="polite"
		>
			Maximum number of Pets is 15, so this Pet cannot be added. Please remove another pet first and try again, or
			start a
			separate quote if there are more pets to add.
		</p>
	</div>
	<div *ngIf="isAgeError">
	</div>
</mat-dialog-content>
